import i18n from '../../i18n'
import requiredRules from './requiredRules'

const usernameRules = (v) => [
  ...requiredRules(v),
  !/[^\w-.@]/.test(v) || i18n.t('warnings.validation.username')
]

export default usernameRules
